
<div>
    <dynamic-table [props]="props">
        <table class="table">
            <thead>
                <tr class="table-header">
                    <th id="Title" class="table-header-title">{{'termsAndConditions.cookieMessageTitle' | translate}}</th>
                    <th id="StartDate" class="table-header-title">{{'termsAndConditions.valability' | translate}}</th>
                    <th id="Required" class="table-header-title">{{'termsAndConditions.required' | translate}}</th>
                    <th id="Status" class="table-header-title">{{'termsAndConditions.status' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let cookie of cookies">
                    <tr class="table-container row-container" [ngClass]="{'border-active-cookie': cookie?.active}">
                        <td HJSuppress id="Title" class="column-content table-main-td cursor-pointer" (click)="redirectCookieConsent(cookie.cookieMessageId)">
                            {{cookie.title}}
                        </td>
                        <td HJSuppress id="StartDate" class="column-content">
                            {{cookie.startDate | localizedDate}} {{cookie.endDate ? '-': ''}} {{cookie.endDate | localizedDate}}
                        </td>
                        <td id="Required" class="column-content">
                            {{cookie.required ? ('termsAndConditions.isRequired' | translate) : ('termsAndConditions.isNotRequired' | translate)}}
                        </td>
                        <td HJSuppress id="Status" class="column-content">               
                                @switch (cookie.status) {
                                    @case (cookieStatus.ACTIVE) {
                                        <div class="status" [ngClass]="cookie.status">
                                            {{'termsAndConditions.statusMessage.active' | translate}}
                                        </div>
                                    }
                                    @case (cookieStatus.UPCOMING) {
                                        <div class="status" [ngClass]="cookie.status">
                                            {{'termsAndConditions.statusMessage.upcoming' | translate}}
                                        </div>
                                    }
                                    @case (cookieStatus.EXPIRED) {
                                        <div class="status" [ngClass]="cookie.status">
                                            {{'termsAndConditions.statusMessage.expired' | translate}}
                                        </div>
                                    }
                                }
                        </td>
                        <td class="column-content">
                            <button class="btn delete-btn delete-btn-circle" 
                                *ngIf="isPastExpiryDate(cookie.endDate) || !cookie.endDate"
                                [disabled]="cookie.hasCookieConsents"
                                (click)="editCookie(cookie.cookieMessageId)">
                                <i class="app-icon icon icon-edit icon-lg text-secondary"></i>
                            </button>
                        </td>
                        <td class="column-content">
                            <button class="btn delete-btn delete-btn-circle" 
                                *ngIf="isPastStartDate(cookie.startDate)"
                                [disabled]="!isPastStartDate(cookie.startDate)"
                                (click)="editCookie(cookie.cookieMessageId)">
                                <i class="app-icon icon icon-search icon-lg"></i>
                            </button>
                        </td>

                        <td class="column-content">
                            <button class="btn delete-btn delete-btn-circle"
                                *ngIf="!isPastStartDate(cookie.startDate)"
                                [disabled]="isPastStartDate(cookie.startDate)"
                                (click)="deleteCookie(cookie.cookieMessageId)">
                                <i class="app-icon icon icon-delete icon-lg"></i>
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </dynamic-table>
</div>
